import Vue from 'vue'
import axios from 'axios';
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import wechat from 'weixin-js-sdk';


Vue.use(Router)

const router = new Router({
  mode: "history",
  // base: process.env.BASE_URL,
  routes: [
    //重定向
    {
      path: "/",
      redirect: "/index",
      meta: {
        title: '首页'
      }
    },
    //首页
    {
      path: "/index",
      name: "index",
      component: () => import('@/views/index/index.vue'),
      meta: {
        title: '首页'
      }
    },
    {
      path: "/about",
      name: "about",
      component: () => import('@/views/about/index.vue'),
      meta: {
        title: '关于我们'
      }
    },
    {
      path: "/bingo",
      name: "bingo",
      component: () => import('@/views/bingo/index.vue'),
      meta: {
        title: '宾果游戏'
      }
    },
    {
      path: "/download",
      name: "download",
      component: () => import('@/views/download/index.vue'),
      meta: {
        title: '游戏下载'
      }
    },
    {
      path: "/introduce",
      name: "introduce",
      component: () => import('@/views/introduce/index.vue'),
      meta: {
        title: '战略介绍'
      }
    },
    {
      path: "/recruitment",
      name: "recruitment",
      component: () => import('@/views/recruitment/index.vue'),
      meta: {
        title: '人才招聘'
      }
    },
    {
      path: "/recharge",
      name: "recharge",
      component: () => import('@/views/recharge/index.vue'),
      meta: {
        title: '充值中心'
      }
    },
    {
      path: "/supervision",
      name: "supervision",
      component: () => import('@/views/supervision/index.vue'),
      meta: {
        title: '家长监护'
      }
    },
    {
      path: "/login",
      name: "login",
      component: () => import('@/views/login/index.vue'),
      meta: {
        title: '登录'
      }
    },
    {
      path: "/register",
      name: "register",
      component: () => import('@/views/register/index.vue'),
      meta: {
        title: '注册'
      }
    },
    {
      path: "/forget",
      name: "forget",
      component: () => import('@/views/forget/index.vue'),
      meta: {
        title: '注册'
      }
    },
    //重定向
    {
      path: '*',
      redirect: '/',
      meta: {
        title: '首页'
      }
    },
  ]
})

function onBridgeReadyHide() {
  WeixinJSBridge.call('hideOptionMenu');
}
function onBridgeReadyShow() {
  WeixinJSBridge.call('showOptionMenu');
}
//路由开始跳转进度条结束
router.beforeEach((to, from, next) => {
  NProgress.start()
  window.scrollTo(0,0)
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

//路由跳转完毕进度条消失
router.afterEach(() => {
  NProgress.done()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js